import { GET_FEATURE_OUTAGE_NOTIFICATION } from '../constants/apiRoutes';
import { ApiError, NotificationsResult } from '../types/Content';
import { httpClient } from '../utils/httpClient';
import Logger from '../utils/logger';

const handleError = () => {
  const errorResponse = {
    success: false,
    data: null,
  };

  return errorResponse;
};

export const fetchNotifications = async (): Promise<NotificationsResult> => {
  try {
    const response = await httpClient.get<NotificationsResult>(
      GET_FEATURE_OUTAGE_NOTIFICATION
    );

    const { data, success } = response as NotificationsResult;
    if (success && data) {
      return {
        success: true,
        data,
      };
    }
    return handleError();
  } catch (error) {
    const fetchError = error as ApiError;
    Logger.error(new Error(fetchError.message));
    return handleError();
  }
};
